var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02051 16.1V16.07V15.84V15.8083V16.1ZM1.02051 16.1V12.78C1.02051 12.78 1.72051 9.16996 5.39051 6.95996H10.6905C10.6905 6.95996 15.1605 10.39 15.0305 12.98V16.17H12.1905L11.6205 15.44H4.31051L3.73051 16.1H1.02051Z",
    stroke: "#1F2226",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42023 5.39062H5.49023V6.61062H7.42023V5.39062Z",
    fill: "#1F2226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72969 9.75H5.42969V11.1H6.72969V9.75Z",
    fill: "#1F2226"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67988 9.75H7.37988V11.1H8.67988V9.75Z",
    fill: "#1F2226"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5998 9.75H9.2998V11.1H10.5998V9.75Z",
    fill: "#1F2226"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72969 11.7197H5.42969V13.0697H6.72969V11.7197Z",
    fill: "#1F2226"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67988 11.7197H7.37988V13.0697H8.67988V11.7197Z",
    fill: "#1F2226"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5998 11.7197H9.2998V13.0697H10.5998V11.7197Z",
    fill: "#1F2226"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99445 6H7.06445V7.22H8.99445V6Z",
    fill: "#1F2226"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5902 5.39062H8.66016V6.61062H10.5902V5.39062Z",
    fill: "#1F2226"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21744 1.56365L4.02004 5.70014L0.640039 6.72014L0.540039 3.24014C0.540039 3.24014 7.99454 -1.35474 15.45 3.64014L15.42 6.68014L11.9973 5.54014L10.7447 1.61365L5.21744 1.56365Z",
    stroke: "#1F2226",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.ea0c59cb.svg";
export { ForwardRef as ReactComponent };